import {User} from '../../models/user';
import {UserService} from '../../services/user.service';
import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  users: any[]

  constructor(private user_service: UserService) {
  }

  ngOnInit() {
    this.user_service.getAll()
      .subscribe(users => {
          this.users = users.results

        },
        error => {
          alert("Could not fetch all users")
        })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/users/users.component.ts